import supabase from '../supabase/supabase';

const editableFields = new Set(['status', 'featured']);

export async function updateProductListField(productId, field, value) {
  if (!editableFields.has(field)) {
    throw new Error('This product setting cannot be changed here.');
  }

  if (
    (field === 'status' && !['active', 'draft'].includes(value))
    || (field === 'featured' && typeof value !== 'boolean')
  ) {
    throw new Error('The selected product setting is invalid.');
  }

  const { error } = await supabase
    .from('zevi_products_20260925')
    .update({
      [field]: value,
      updated_at: new Date().toISOString()
    })
    .eq('id', productId);

  if (error) {
    throw new Error(
      field === 'status'
        ? 'Product status could not be updated.'
        : 'Homepage featured setting could not be updated.'
    );
  }
}